// extracted by mini-css-extract-plugin
export default {"root":"c3FS0E4Dkx","divider":"EmSBakPoJ6"};